<script setup lang="ts">
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import ChatPanel from "@/features/dream-home/components/ChatPanel.vue";
import { useMate } from "@/stores/mate";
import { onActivated, onBeforeMount, onMounted, ref } from "vue";
import { onBeforeRouteLeave, useRouter } from "vue-router";

const router = useRouter();
const mateStore = useMate();

const showChatPanel = ref(false);

onBeforeRouteLeave((to, from, next) => {
  if (showChatPanel.value) {
    showChatPanel.value = false;
    return;
  }
  next();
});

onBeforeMount(() => {
  mateStore.getMateList(true);
});

onActivated(() => {
  mateStore.getMateList(true);
});

const scroller = ref<ThreadListInstance>();

const height = ref(0);

onMounted(() => {
  // Dream Home specific initialization can go here if needed
});

onActivated(() => {
  if (height.value) {
    scroller.value?.scrollTo(height.value);
  }
});
</script>

<template>
  <div class="grid grid-rows-[auto_1fr] w-full h-full overflow-hidden">
    <ThreadsNav :show-center="false">
      <template #right>
        <CrystalPowerCount />
      </template>
    </ThreadsNav>
    <div class="w-full h-full overflow-y-auto">
      <div>
        <div class="flex flex-col px-2 py-4 gap-2 mb-2 bg-base-200">
          <div
            @click="router.push({ name: 'dreamHome' })"
            class="w-full aspect-[4/1] bg-cover rounded overflow-hidden relative cursor-pointer"
            :style="{
              backgroundImage: `url('/img/dream-room-preview.png')`,
            }"
          >
            <div
              class="absolute inset-0 bg-black/80 flex items-end justify-end p-1"
            >
              <div class="btn btn-primary font-[Cubic]">
                {{ $t("Buttons.enterHome") }} >>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-2 w-full text-xs">
            <button
              class="btn btn-xs btn-outline flex-1 rounded flex flex-col"
              @click="showChatPanel = true"
            >
              <i class="iconify mdi--history" />
              {{ $t("Buttons.homeActivityLog") }}
            </button>
          </div>
        </div>
      </div>
      <VanPopup
        position="bottom"
        v-model:show="showChatPanel"
        class="h-[90%] grid grid-rows-[auto_1fr]"
        round
      >
        <ThreadsNav show-back :go-back="() => (showChatPanel = false)">
          <template #center>
            <div>{{ $t("Buttons.homeActivityLog") }}</div>
          </template>
        </ThreadsNav>
        <ChatPanel class="h-full w-full" />
      </VanPopup>
    </div>
  </div>
</template>
